<template>
  <div class="wrap">
    <p class="description">Compare your weekly average in each category vs. the league average to identify areas of opportunity.</p>
    <div class="top-dropdown">
      <h3 class="nav-panel-header">
        <span>View:</span>
      </h3>
      <form @submit.prevent>
        <select v-model="categoryIndex">
          <option :value="i" v-for="(category, i) in categoryCompare" v-bind:key="i">{{category.name}}</option>
        </select>
      </form>
    </div>
    <div class="table-wrap">
      <div class="fl-table" v-if="viewChosen">
        <div class="fl-row header-row">
          <div class="fl-row-inner">
            <table-cell>
              <h3 class="h6">Team</h3>
            </table-cell>
            <table-cell v-for="(category, i) in categoryCompare[categoryIndex].columns" v-bind:key="i" class="fl-cell">
              <h3 class="h6">{{category.display_name}}</h3>
            </table-cell>
          </div>
        </div>
        <div class="table-content">
          <div v-for="(row, i) in categoryCompare[categoryIndex].rows"
            v-bind:key="i"
            class="fl-row"
            :class="{'your-row': row.team && row.team.is_owned_by_current_login, 'highlight': !row.team}">
            <div class="fl-row-inner">
              <table-cell>
                <p v-if="row.team">
                  {{row.team.name}}
                </p>
                <p v-else>League Avg.</p>
              </table-cell>
              <!-- <div
                v-for="(score, j) in row.scores"
                v-bind:key="j"
                class="fl-cell"
                :class="{
                  'victory': score.lost_matchup === false,
                  'defeat': score.lost_matchup === true
                }"
              >
              <table-cell :value="score.strValue ? score.strValue : score.value"/> -->
              <table-cell
                v-for="(score, j) in row.scores"
                v-bind:key="j"
                :class="{
                  'victory': score.lost_matchup === false,
                  'defeat': score.lost_matchup === true
                }"
                :value="score.strValue ? score.strValue : score.value"
              />

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableCell from '@/components/cell/cell.vue'

export default {
  name: "category",
  data() {
    return {
      categoryIndex: 0,
      categoryCompare: {},
      catagoryRequest: false
    };
  },
  components: {
    'table-cell': tableCell
  },
  props: ['leagues', 'selectedLeague', 'loaded', 'leagueName'],
  computed: {
    viewChosen: function() {
      return this.leagueName && this.catagoryRequest
    }
  },
  created: function() {
    if(this.selectedLeague.yahoo_object.league_key) {
      this.selectCategory()
    }
  },
  methods: {
    selectCategory: async function() {
      try {
        this.$store.dispatch("isLoading", true);
        this.categoryCompare = await this.$store.state.apiService.getCategoryCompare(
          this.selectedLeague.yahoo_object.league_key
        );
      } catch (e) {
        if (e.response && e.response.status && e.response.status === 403) {
          this.$store.dispatch("login", true);
        }
      } finally {
        this.$store.dispatch("isLoading", false);
        this.catagoryRequest = true
      }
    }
  },
  watch: {
    leagueName: function () {
      this.selectCategory()
    }
  }
};
</script>

<style src="./compare-teams.styl" lang="stylus" scoped></style>
